import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=3990686a&scoped=true&"
import script from "./bindPhone.vue?vue&type=script&lang=js&"
export * from "./bindPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindPhone.vue?vue&type=style&index=0&id=3990686a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990686a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3990686a')) {
      api.createRecord('3990686a', component.options)
    } else {
      api.reload('3990686a', component.options)
    }
    module.hot.accept("./bindPhone.vue?vue&type=template&id=3990686a&scoped=true&", function () {
      api.rerender('3990686a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/playerDetails_yujian/components/bindPhone.vue"
export default component.exports